export function disableBodyScrolling(disable: boolean = true, scrollPosition: number = 0, useIOSHack: boolean = false) {

    // Disable Scroll
    if (disable) {

        // HTML & Body class
        document.documentElement.classList.add('prevent-scroll');
        document.body.classList.add('prevent-scroll');

        // iOS Prevent Scrolling
        if (useIOSHack) {
            scrollPosition = window.scrollY;
            document.body.style.overflow = 'clip';
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollPosition}px`;
            document.body.style.width = '100%';
        }

    // Enable scroll
    } else {

        // HTML & Body class
        document.documentElement.classList.remove('prevent-scroll');
        document.body.classList.remove('prevent-scroll');

        // iOS Enable Scrolling
        if (useIOSHack) {
            document.body.style.removeProperty('overflow');
            document.body.style.removeProperty('position');
            document.body.style.removeProperty('top');
            document.body.style.removeProperty('width');
            window.scrollTo(0, scrollPosition);
        }

        // Remove body scrolled classes
        document.body.classList.remove('page-scrolled-down');
        document.body.classList.remove('page-scrolled-up');
    }

    // Return scroll position
    return scrollPosition;
}
